import Request from "@/services/api/Request";

import { API_URL } from "@/constants";

export const routes = {
  albums: `${API_URL}/albums`,
  popular: `${API_URL}/albums/popular`,
  latest: `${API_URL}/albums/latest`,
  favorite: `${API_URL}/albums/favorite`,
  album: id => `${API_URL}/albums/${id}/show`,
  editing: id => `${API_URL}/albums/${id}/edit`,
  review: id => `${API_URL}/albums/${id}/review`,
  like: id => `${API_URL}/albums/${id}/like`,
  tracks: id => `${API_URL}/albums/${id}/tracks`,
  releated: id => `${API_URL}/albums/${id}/same`,
  delete: id => `${API_URL}/albums/${id}`,
  update: id => `${API_URL}/albums/${id}`,
  create: `${API_URL}/personal/artist/albums`,
  genres: id => `${API_URL}/albums/${id}/genres`,
  uploadTracks: id => `${API_URL}/albums/${id}/tracks`,
  sortTracks: id => `${API_URL}/albums/${id}/tracks/sort`,
  cover: id => `${API_URL}/albums/${id}/image`,
  massUpdate: id => `${API_URL}/albums/${id}/mass-update`
};

export const request = new Request("albums");

export default {
  fetch(type, params = {}) {
    switch (type) {
      case "popular":
        return this.popular(params);
      case "latest":
        return this.latest(params);
      case "favorite":
        return this.favorite(params);
      case "album":
        return this.one(params);
      case "editing":
        return this.editing(params);
      case "review":
        return this.review(params);
      case "releated":
        return this.releated(params);
      default:
        return this.byIds(params);
    }
  },
  byIds(params) {
    return params.ids && params.ids.length
      ? request.get(routes.albums, params)
      : Promise.resolve({});
  },
  one(params) {
    return request.get(routes.album(params.id));
  },
  editing(params) {
    return request.get(routes.editing(params.id));
  },
  review(params) {
    return request.get(routes.review(params.id));
  },
  popular(params) {
    return request.get(routes.popular, params);
  },
  latest(params) {
    return request.get(routes.latest, params);
  },
  favorite(params) {
    return request.get(routes.favorite, params);
  },
  like(id) {
    return request.post(routes.like(id));
  },
  tracks(id) {
    return request.get(routes.tracks(id));
  },
  releated(params) {
    return request.get(routes.releated(params.id), params);
  },
  delete({ albumId }) {
    return request.delete(routes.delete(albumId));
  },
  create(params) {
    return request.post(routes.create, params);
  },
  update(params) {
    return request.post(routes.update(params.id), params);
  },
  genres(params) {
    return request.post(routes.genres(params.id), params);
  },
  sortTracks(params) {
    return request.post(routes.sortTracks(params.id), params);
  },
  async uploadTrack(params) {
    const { id, track } = params;
    const formData = new FormData();

    formData.append("tracks[]", track.file);

    const { payload } = await request.post(routes.uploadTracks(id), formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress(e) {
        track.progress = Math.trunc((e.loaded / e.total) * 100);
      }
    });

    const { tracks } = payload;

    return {
      payload: {
        track: tracks[0] || null
      }
    };
  },
  cover(params) {
    const { id, image } = params;
    const formData = new FormData();

    formData.append("image", image);

    return request.post(routes.cover(id), formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  async save({ id, title, type, year, image, genres = [], tracks = [] }) {
    const formData = new FormData();

    formData.append("title", title);
    formData.append("year", year);
    formData.append("type", type);

    if (genres.length) {
      genres.forEach(genre => {
        formData.append("genres[]", genre);
      });
    } else {
      formData.append("genres[]", "");
    }

    if (tracks.length) {
      tracks.forEach(track => {
        try {
          formData.append("tracks[]", JSON.stringify(track));
        } catch (error) {
          console.error(error);
        }
      });
    } else {
      formData.append("tracks[]", "");
    }

    if (image) {
      formData.append("image", image);
    }

    return request.post(routes.massUpdate(id), formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
